<template>
    <b-modal id="settings-modal" title="에너지 요금 관리" size="xl" hide-footer modal-class="ebc-settings-modal">
        <div class="settings-modal-container">
            <nav class="settings-nav" aria-label="설정 메뉴">
                <template v-for="group in navGroups">
                    <span :key="`${group.label}-label`" class="settings-nav-group">{{ group.label }}</span>
                    <button
                        v-for="item in group.tabs"
                        :key="item.id"
                        type="button"
                        :class="['settings-nav-item', { active: currentTab === item.id }]"
                        @click="currentTab = item.id"
                    >
                        <i :class="item.icon" aria-hidden="true"></i>
                        {{ item.label }}
                    </button>
                </template>
            </nav>

            <div class="settings-content">
                <div class="tab-content">
                    <!-- 계산·조회·검증·비교는 입력과 결과를 탭 전환 사이에 유지한다 -->
                    <keep-alive :include="keepAliveTabs">
                        <component :is="activeTab.component" :key="activeTab.id" />
                    </keep-alive>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import SupplierManagement from "../management/SupplierManagement.vue";
import CostManagement from "../management/CostManagement.vue";
import ContractManagement from "../management/ContractManagement.vue";
import BillCalculation from "../calculation/BillCalculation.vue";
import BillInquiry from "../calculation/BillInquiry.vue";
import BillVerification from "../calculation/BillVerification.vue";
import RateComparison from "../calculation/RateComparison.vue";

const NAV_GROUPS = [
    {
        label: "기준 정보",
        tabs: [
            { id: "supplier", label: "공급자", icon: "fas fa-building", component: SupplierManagement },
            { id: "cost", label: "요금제", icon: "fas fa-file-invoice-dollar", component: CostManagement },
            { id: "contract", label: "계약", icon: "fas fa-file-signature", component: ContractManagement },
        ],
    },
    {
        label: "요금",
        tabs: [
            { id: "calculate", label: "계산", icon: "fas fa-calculator", component: BillCalculation },
            { id: "inquiry", label: "조회", icon: "fas fa-search", component: BillInquiry },
            { id: "verify", label: "검증", icon: "fas fa-check-circle", component: BillVerification },
            { id: "compare", label: "비교", icon: "fas fa-balance-scale", component: RateComparison },
        ],
    },
];

export default {
    name: "SettingsModal",
    data() {
        return {
            currentTab: "supplier",
            navGroups: NAV_GROUPS,
            keepAliveTabs: ["BillCalculation", "BillInquiry", "BillVerification", "RateComparison"],
        };
    },
    computed: {
        activeTab() {
            return NAV_GROUPS.flatMap((g) => g.tabs).find((t) => t.id === this.currentTab);
        },
    },
    methods: {
        show() {
            this.$bvModal.show("settings-modal");
        },
        hide() {
            this.$bvModal.hide("settings-modal");
        },
    },
};
</script>

<style scoped>
.settings-modal-container {
    display: flex;
    flex-direction: row;
    height: 85vh;
    min-height: 500px;
    gap: 14px;
}

.settings-nav {
    flex: 0 0 160px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 4px 2px;
}

.settings-nav-group {
    padding: 10px 10px 4px;
    font-size: 11px;
    font-weight: 600;
    color: var(--ebc-text-muted);
}

.settings-nav-group:first-child {
    padding-top: 2px;
}

.settings-nav-item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 7px 10px;
    border: none;
    border-radius: var(--ebc-radius-sm);
    background: transparent;
    color: var(--ebc-text-sub);
    font-size: 13px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
    transition:
        background 0.2s var(--ebc-ease),
        color 0.2s var(--ebc-ease);
}

.settings-nav-item i {
    width: 14px;
    font-size: 12px;
    color: var(--ebc-text-muted);
}

.settings-nav-item:hover:not(.active) {
    background: var(--ebc-track);
    color: var(--ebc-text);
}

.settings-nav-item:hover:not(.active) i {
    color: var(--ebc-text-sub);
}

.settings-nav-item:focus {
    outline: none;
}

.settings-nav-item.active {
    background: var(--ebc-surface);
    color: var(--ebc-primary);
    box-shadow: var(--ebc-shadow-toggle);
}

.settings-nav-item.active i {
    color: var(--ebc-primary);
}

.settings-content {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    padding: 16px 18px;
    background: var(--ebc-surface);
    border: 1px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-md);
    box-shadow: var(--ebc-shadow-panel);
}

.tab-content {
    height: 100%;
    overflow-y: auto;
}
</style>
